const initialState = {
  loading: false,
  schedules: [],
  error: null,
  date: null,
  idSchedule: null
}

export const SCHEDULE_LOADING = 'SCHEDULE_LOADING' 
export const SET_SCHEDULES = 'SET_SCHEDULES' 
export const SET_DATE = 'SET_DATE' 
export const SET_SCHEDULE = 'SET_SCHEDULE' 
export const RESET_SCHEDULES = 'RESET_SCHEDULES' 

export const schedulesReducer = ( state = initialState, action ) => {
  switch (action.type) {
    case SCHEDULE_LOADING:
      return {
        ...state,
        loading: true
      }

    case SET_SCHEDULES:
      return {
        ...state,
        schedules: action.payload.map((item, idx) => {
          return {
            ...item,
            label: item.date,
            value: idx,
            schedules: item.schedules.map(item2 => {
              return {
                ...item2,
                label: `${ item2.start } - ${item2.end}`,
                value: item2.id
              }

            })
          }
        }),
        loading: false
      }
      
      case SET_DATE:
        return {
          ...state,
          date: action.payload,
        }
      case SET_SCHEDULE:
        return {
          ...state,
          idSchedule: action.payload,
        }

      case RESET_SCHEDULES:
        return initialState
    default:
      return state
  }
}